import { once } from "~/jose_modern/once";

export class TransactionsChartChange extends Event {
  constructor({ id, ...params }) {
    super(id);
    Object.assign(this, { params });
  }
}

function formatNumber(n) {
  const formatOptions =
    Math.abs(n) < 0.01
      ? { maximumSignificantDigits: 2, maximumFractionDigits: 5 }
      : { maximumFractionDigits: 2 };

  return n.toLocaleString(undefined, formatOptions);
}

function createChart(chartId) {
  const chartEl = document.getElementById(chartId);

  if (!chartEl || !window.Chartkick || window.Chartkick.charts[chartId]) return;

  const suffix = chartEl.dataset.suffix;

  function label(context) {
    const prefix = context.dataset.label ? `${context.dataset.label}: ` : "";

    if (context.parsed.y === null) {
      return "";
    }
    return `${prefix}${formatNumber(context.parsed.y)}`;
  }

  function footer(labels) {
    const total = labels.reduce((acc, label) => acc + label.raw, 0);
    const sign = total > 0 ? "+" : "";

    return `Total: ${sign}${formatNumber(total)}${suffix}`;
  }

  function yTicksCallback(value, _index, _ticks) {
    return `${formatNumber(value)}${suffix}`;
  }

  new window.Chartkick.ColumnChart(chartId, chartEl.dataset.url, {
    stacked: true,
    suffix,
    library: {
      maxBarThickness: 120,
      borderSkipped: true,
      plugins: {
        tooltip: {
          callbacks: {
            label,
            footer,
          },
        },
      },
      scales: {
        y: {
          ticks: {
            callback: yTicksCallback,
          },
        },
      },
    },
  });
}

export function initializeChart(chartId) {
  once(document, chartId, () => {
    const eventId = `${chartId}:change`;

    document.addEventListener(eventId, (ev) => {
      if (!window.Chartkick?.charts[chartId]) {
        createChart(chartId);
      } else {
        const chartEl = document.getElementById(chartId);
        const chart = window.Chartkick.charts[chartId];
        if (!chartEl || !chart) return;

        chart.element = chartEl;
        const [path, query] = chart.dataSource.split("?");

        const params = new URLSearchParams(query);
        for (const paramKey in ev.params) {
          params.set(paramKey, ev.params[paramKey]);
        }

        chart.updateData(`${path}?${params.toString()}`);
      }
    });

    document.body.addEventListener("change", (ev) => {
      if (ev.target.id !== "transactions-chart-aggregate-select") return;

      document.getElementById("transactions-chart-aggregate").value = ev.target.value;
      document.dispatchEvent(
        new TransactionsChartChange({ id: eventId, aggregate: ev.target.value })
      );
    });

    document.addEventListener("DOMContentLoaded", () => createChart(chartId));
    window.addEventListener("chartkick:load", () => createChart(chartId), true);
  });
}
